import { Subscription } from 'rxjs';

/**
 * Utility functions for managing RxJS subscriptions in Angular components
 */
export class SubscriptionUtils {

  /**
   * Safely unsubscribes from an array of subscriptions.
   * Handles null/undefined subscriptions.
   * 
   * @param subscriptions - Array of subscriptions to unsubscribe from
   */
  static safeUnsubscribe(subscriptions: Subscription[]): void {
    if (!subscriptions) {
      return;
    }

    subscriptions.forEach(subscription => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }

  /**
   * Safely unsubscribes from a single subscription.
   * Handles null/undefined subscription.
   * 
   * @param subscription - Subscription to unsubscribe from
   */
  static safeUnsubscribeSingle(subscription: Subscription): void {
    if (subscription) {
      subscription.unsubscribe();
    }
  }

  /**
   * Clears an array of subscriptions by unsubscribing and setting to empty array.
   * 
   * @param subscriptions - Array of subscriptions to clear
   */
  static clearSubscriptions(subscriptions: Subscription[]): void {
    SubscriptionUtils.safeUnsubscribe(subscriptions);
    if (subscriptions) {
      subscriptions.length = 0;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/utils/subscription-utils.ts